import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-property-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './property-stats.component.html',
  styleUrl: './property-stats.component.scss'
})
export class PropertyStatsComponent {

}
